import React from 'react';
import { FileText } from 'lucide-react';
export function Resources() {
  const resources = ['Peer Mentorship Circle (starts Fall 2026)', 'San Diego networking events & workshops', 'Directory of community organizations and mentors', 'Articles, videos and practical guides', 'Curated courses, tools, and related services'];
  return <section id="resources" className="py-20 md:py-24 px-6 md:px-12 bg-teal text-white" data-id="element-134">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-135">
        <div data-id="element-136">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/20 border border-accent/40 text-accent text-xs font-medium uppercase tracking-widest mb-5" data-id="element-137">
            <span className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse" data-id="element-138"></span>
            Coming soon
          </div>
          <h2 className="text-4xl md:text-5xl font-serif mb-6 text-clay" data-id="element-139">
            SD Career Resources
          </h2>
          <p className="text-lg text-mist/80 mb-8" data-id="element-140">
            Handpicked courses, videos, articles, local meetups, communities,
            and tools to help you get ahead!
          </p>
          <button type="button" disabled aria-disabled="true" className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 border border-white/20 text-mist/60 font-medium rounded-md cursor-not-allowed" data-id="element-141">
            <FileText className="w-5 h-5" data-id="element-142" />
            Notion Workspace · Coming soon
          </button>
        </div>

        <ul className="grid grid-cols-1 gap-3" data-id="element-143">
          {resources.map((item, i) => <li key={i} className="bg-white/10 border border-white/20 rounded-lg px-4 py-3.5 text-sm text-mist flex items-center gap-3" data-id="element-144">
              <span className="w-1.5 h-1.5 rounded-full bg-sage shrink-0" data-id="element-145"></span>
              <span data-id="element-146">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}